import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setAggregator, setAggregatorRef, setBillType, setBtnSelected, setCustomer, setCustomerTextfieldInput, setCustomerWallet, setOrderWaiter, setSearchBarInput, setSingleCusInfo, setDeliveryBoy} from './topBarSliceBilling'
import { Autocomplete, Dialog, IconButton, TextField, createFilterOptions } from '@mui/material'
import SearchIcon from "@mui/icons-material/Search";
import { defaultCustomerForPOSAPI } from '../API/billingFloorSection'
import { setDialogBox, setErrorSnack, setOrderIdInPOS, setPageIndex, setSnackMsg } from '../Slice/billingScreenSlice'
import { findObjFromList } from '../../../../../Js/generalFunctions'
import { listHeldOrders, listOrdersForBillingAPI } from '../API/viewOrderSection'
import { getCustomerWallet } from '../API/billingPaymentSection'
import { listReservationList } from '../API/billingReservation'
import { setApplyBtnClicked, setFilteredOrderType, setFilteredStatus } from '../Utilities/filterButtonSlice'
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import EditIcon from '@mui/icons-material/Edit';
import AddCustomerFromReservation from '../Utilities/AddCustomerFromReservation'
import { getSingleCustomerInfoAPICall } from '../API/billingScreenSection'
import { setVisibleKeyboard } from '../../../../Single Components/customKeyBoardSlice';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import CustomeKeyBoard from '../../../../Single Components/CustomeKeyBoard';
import CustomerListPopup from '../Utilities/CustomerListPopup';
import { successSnackMsg } from '../../../../Custom Hooks/SnackkBarUtilities';
import { setSelfDeliveryCharge, setSelfDeliveryKm } from './topBarSliceBilling';

function TopBar() {

const menuRef=useRef()
const billTypeTriggerRef=useRef(null)
const billTypeDropdownRef=useRef(null)

const userInfo=useSelector((state)=>state.loginResponseSlice.value)

// api responses
const customerList = useSelector((state) => state.allCustomerListSlice.value);

// const createObjectsArray = (num) => {
//     return Array.from({ length: num }, (_, index) => ({
//         _id: `unique_id_${index}`,
//         name: `Name_${index}`,
//         mobileNo: `000000000${index % 10}`
//     }));
// };

// const customerList = createObjectsArray(8000);

const customerAutocompletRef=useRef(null)

// store states
const {customer,btnClicked,onGoingOrderCount,aggregator,searchBarInput,aggregatorRef,customerTextfieldInput,selfDeliveryKm,deliveryBoy}=useSelector((state)=>state.topBarSliceBilling)
const {heldOrders}=useSelector((state)=>state.viewOrdersBillingSlice)
const {reservationList}=useSelector((state)=>state.reservationSlice)
const {keyBoardVisible} = useSelector((state) => state.customKeyBoardSlice);


const {singleOrderInfo,dialogOpen} = useSelector((state) => state.billingScreenSlice);
const {aggregatorList}=useSelector((state)=>state.aggregatorSlice)
const allActiveEmpList = useSelector((state) => state.allActiveEmployeeSlice.value);
const dispatch=useDispatch()
// order types list
const switchTabs=["Dine In","Take Away","Delivery"]

// useStates
const [addCustomerDialog, setAddCustomerDialog] = useState(false);
const [billTypeOption,setBillTypeOption]=useState("Dine In")
const [billTypeDropdownOpen,setBillTypeDropdownOpen]=useState(false)
const [showAggregator,setShowAggregator]=useState(false)
const [aggregatorRefValidation, setAggregatorRefValidation] = useState(false);
const branchConfig = useSelector((state) => {
    // Prioritize branchSettingsSliceNew which has deliveryChargeMode
    return state.branchSettingsSliceNew?.rowData || state.newBillingSlice?.branchConfigurationList;
});
const [kmDialogOpen, setKmDialogOpen] = useState(false);
const [kmInput, setKmInput] = useState("");
const [kmDialogError, setKmDialogError] = useState(null);
const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState(null);
// functions
const onChangeBillType=(key)=>()=>{
    let option=key==="Dine In"?"DINEIN":key==="Take Away"?"TAKEAWAY":"DELIVERY"
    dispatch(setBillType(option))
    setBillTypeOption(key)
    // option==="DELIVERY" ? setShowAggregator(!showAggregator):setShowAggregator(false)
     // Reset aggregator and category filtering when not Delivery
     if (option !== "DELIVERY") {
        dispatch(setAggregator(null)); // Clear selected aggregator
        setShowAggregator(false); // Hide aggregator list
        // Clear delivery KM/charge when leaving Delivery
        dispatch(setSelfDeliveryKm(0));
        dispatch(setSelfDeliveryCharge(0));
    } else {
        option === "DELIVERY" ? setShowAggregator(!showAggregator) : setShowAggregator(false);
        // Don't open dialog here - let useEffect handle it after state updates
    }
}

const closeCustomerDialog=()=>{
    setAddCustomerDialog(false)
    dispatch(setDialogBox(null))
    dispatch(setVisibleKeyboard(null))
    
}

const buttonsOnClick=(option)=> {
    dispatch(setSearchBarInput(null))
    dispatch(setOrderIdInPOS(null))
    if(btnClicked===option){
        dispatch(setBtnSelected(null))
    }else{
        dispatch(setBtnSelected(option))
        if(option==="viewOrder"){
            dispatch(setFilteredOrderType(null))
            dispatch(setFilteredStatus(null))
            listOrdersForBillingAPI({branchId:userInfo?.branchPk,type:2})
        }
        if(option==="heldOrder"){
            dispatch(setFilteredStatus(null))
            listHeldOrders({branchId:userInfo?.branchPk,type:1})
        }
        if(option==="reservation"){
            listReservationList({branchId:userInfo?.branchPk})
        }
    }
}

// const aggregatorSelected=(item)=>()=>{
//     dispatch(setAggregator((aggregator?._id===item?._id)?null:item))
//     dispatch(setAggregatorRef(null))
//     if(!(aggregator?._id===item?._id)){
//         item?.isSelf?setShowAggregator(false):dispatch(setDialogBox("aggregatorRef"))
//         successSnackMsg(`${item?.name} : selected for delivery`)
//     }
// }
const aggregatorSelected = (item) => () => {
    const selectedAggregator = {
      ...item,
      aggregatorCategoryId: item.aggregatorCategoryId || []
    };
    
    dispatch(setAggregator((aggregator?._id === item?._id) ? null : selectedAggregator));
    dispatch(setAggregatorRef(null));
    
    if (!(aggregator?._id === item?._id)) {
      // Check if this aggregator should use delivery charge settings
      const deliveryEnabled = branchConfig?.deliveryCharge;
      const mode = branchConfig?.deliveryChargeMode || 'flat';
      const deliveryChargeAggregators = branchConfig?.deliveryChargeAggregatorId || [];
      const isInDeliveryChargeList = deliveryChargeAggregators.some(agg => agg?.aggregatorId === item?._id);
      
      console.log('🎯 Aggregator selected:', { 
        name: item?.name, 
        isSelf: item?.isSelf,
        mode, 
        deliveryEnabled,
        isInDeliveryChargeList,
        deliveryChargeAggregators
      });
      
      if (item?.isSelf) {
        setShowAggregator(false);
        // If delivery charge enabled and mode requires KM, open dialog
        if (deliveryEnabled && (mode === 'per_km' || mode === 'km_range') && isInDeliveryChargeList) {
          console.log('✅ Opening KM dialog for self aggregator');
          setKmInput("");
          setKmDialogError(null);
          setKmDialogOpen(true);
        } else {
          // Self aggregator NOT in delivery charge list - clear KM and delivery boy
          console.log('⏸️ Not opening KM dialog - mode:', mode, 'inList:', isInDeliveryChargeList);
          if (!isInDeliveryChargeList) {
            console.log('🧹 Clearing KM and delivery boy - self aggregator not in delivery charge list');
            dispatch(setSelfDeliveryKm(0));
            dispatch(setSelfDeliveryCharge(0));
            dispatch(setDeliveryBoy(null));
          }
        }
      } else {
        // For non-self aggregators, check if they're in the delivery charge list
        if (deliveryEnabled && (mode === 'per_km' || mode === 'km_range') && isInDeliveryChargeList) {
          console.log('✅ Opening KM dialog for aggregator:', item?.name);
          setKmInput("");
          setKmDialogError(null);
          setKmDialogOpen(true);
          setShowAggregator(false);
        } else {
          // Aggregator NOT in delivery charge list - clear KM and delivery boy to avoid stale data
          console.log('🧹 Clearing KM and delivery boy - aggregator not in delivery charge list');
          dispatch(setSelfDeliveryKm(0));
          dispatch(setSelfDeliveryCharge(0));
          dispatch(setDeliveryBoy(null));
          dispatch(setDialogBox("aggregatorRef"));
        }
      }
      successSnackMsg(`${item?.name} selected for delivery`);
      
      // Add notification for empty category restrictions
      if (item.aggregatorCategoryId?.length === 0) {
        successSnackMsg("This aggregator has no category restrictions - showing all categories");
      }
    }
  };

const searchInputOnChange=(e)=>{
    dispatch(setSearchBarInput(e.target.value))
    dispatch(setApplyBtnClicked("clicked"));
    dispatch(setPageIndex(0));
}

const customerTextfieldChange=(newInputValue)=>{
    dispatch(setCustomerTextfieldInput(newInputValue))
}

const onCloseAggReference=()=>{
    dispatch(setDialogBox(null))
    dispatch(setAggregatorRef(null))
    dispatch(setAggregator(null))
    setShowAggregator(true)
}

useEffect(()=>{
    if(customer!==null){
        getSingleCustomerInfoAPICall({_id:customer?._id})
    }else{
        dispatch(setSingleCusInfo(null))
        dispatch(setCustomerWallet(null))
    }
},[customer])
useEffect(()=>{
    // console.log(singleOrderInfo, "singleOrderInfo?.cusId");
    if(singleOrderInfo!==null){
        let cusObj=findObjFromList("_id",customerList,"cusId",singleOrderInfo)
        dispatch(setCustomer(cusObj))

        cusObj!==null &&getCustomerWallet({cusId:singleOrderInfo?.cusId})
        dispatch(setAggregator(findObjFromList("_id",aggregatorList,"aggregatorId",singleOrderInfo)))
        dispatch(setOrderWaiter(findObjFromList("_id",allActiveEmpList,"waiterId",singleOrderInfo)))
        dispatch(setAggregatorRef(singleOrderInfo?.aggregatorRef || null))
        let key=singleOrderInfo?.ordType
        let option=key==="TAKEAWAY"?"Take Away":key==="DELIVERY"?"Delivery":"Dine In"
        dispatch(setBillType(key))
        setBillTypeOption(option)
    }else{
        if(btnClicked!==null){
            dispatch(setCustomer(null))
        }
        dispatch(setSingleCusInfo(null))
        dispatch(setAggregator(null))
        dispatch(setAggregatorRef(null))
        dispatch(setOrderWaiter(null))
        setBillTypeOption("Dine In")
        dispatch(setBillType("DINEIN"))
    }
},[singleOrderInfo])

// React to branch settings changes: open KM dialog for self-delivery when required, or clear values when disabled
useEffect(() => {
    const mode = branchConfig?.deliveryChargeMode || 'flat';
    const deliveryEnabled = !!branchConfig?.deliveryCharge;
    const isDeliveryBill = billTypeOption === 'Delivery';
    
    console.log('🔧 Branch config useEffect fired:', { mode, deliveryEnabled, isDeliveryBill, isSelf: aggregator?.isSelf, aggregatorName: aggregator?.name });
    
    if (!deliveryEnabled) {
        // Clear stale values when delivery charge disabled
        console.log('❌ Delivery disabled - clearing KM values');
        dispatch(setSelfDeliveryKm(0));
        dispatch(setSelfDeliveryCharge(0));
        setKmDialogOpen(false);
        return;
    }
    // If switched to flat, clear km values to avoid stale charges
    if (mode === 'flat') {
        console.log('📏 Flat mode - clearing KM values, closing dialog');
        dispatch(setSelfDeliveryKm(0));
        setKmDialogOpen(false);
        return;
    }
    // Check if current aggregator is in the delivery charge aggregator list
    const isAggregatorInList = branchConfig?.deliveryChargeAggregatorId?.some(
        id => id === aggregator?._id
    );
    
    // If mode requires KM and current aggregator is in the configured list, ensure dialog is visible
    // BUT only if KM hasn't been entered yet (to avoid reopening during payment flow)
    if (isDeliveryBill && isAggregatorInList && (mode === 'per_km' || mode === 'km_range')) {
        if (!selfDeliveryKm || selfDeliveryKm === 0) {
            console.log('📍 Opening KM dialog for', mode, 'mode (KM not entered yet) - aggregator in list:', aggregator?.name);
            setKmDialogOpen(true);
        } else {
            console.log('✅ KM already entered:', selfDeliveryKm, '- not reopening dialog');
        }
    } else {
        console.log('⏸️ Not opening KM dialog:', { isDeliveryBill, isAggregatorInList, aggregatorId: aggregator?._id, mode });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [branchConfig, billTypeOption, aggregator?.isSelf, selfDeliveryKm]);

// Reset KM input whenever dialog opens/closes, but keep last selected delivery boy
useEffect(() => {
    if (kmDialogOpen) {
        setKmInput("");
        setKmDialogError(null);
        // Pre-fill with last selected delivery boy from Redux
        if (deliveryBoy) {
            setSelectedDeliveryBoy(deliveryBoy);
        }
    }
}, [kmDialogOpen, deliveryBoy]);


useEffect(() => {
    const handleClickOutside = (event) => {
        if (
            menuRef.current &&
            !menuRef.current.contains(event.target)
        ) {
            setShowAggregator(false);
        }
        if (
            billTypeTriggerRef.current &&
            !billTypeTriggerRef.current.contains(event.target) &&
            (!billTypeDropdownRef.current || !billTypeDropdownRef.current.contains(event.target))
        ) {
            setBillTypeDropdownOpen(false);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, []);

return (
        <div className="billing-left-first"
        style={{justifyContent:btnClicked &&"space-between",position:"inherit"}}
        >
          {
          !(btnClicked) &&
          <>
          <div
                className="new-billing-order-type-switch"
                ref={billTypeTriggerRef}
                onClick={() => setBillTypeDropdownOpen(prev => !prev)}
                style={{cursor:'pointer'}}
            >
                    <div
                        className={`switch-bill-type active`}
                        style={{ paddingBottom:"0px"}}
                    >
                        <p readOnly style={{ margin: "0", fontSize: "0.9rem" }}>
                            {billTypeOption}
                            <i className={`bi bi-chevron-${billTypeDropdownOpen ? 'up' : 'down'}`} style={{marginLeft:4,fontSize:'0.7rem'}}/>
                        </p>
                    </div>
            </div>

            {billTypeDropdownOpen && (
              <div
                ref={billTypeDropdownRef}
                className="new-billing-order-type-switch"
                style={{
                  position: 'fixed',
                  top: billTypeTriggerRef.current ? billTypeTriggerRef.current.getBoundingClientRect().bottom + 2 : 0,
                  left: billTypeTriggerRef.current ? billTypeTriggerRef.current.getBoundingClientRect().left : 0,
                  zIndex: 1100,
                  boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
                  borderRadius: 5,
                  flexDirection: 'column',
                  padding: '4px 0',
                  backgroundColor: '#fff',
                }}
              >
                {
                    switchTabs?.map((option) => (
                        <div
                            key={option}
                            className={`switch-bill-type ${billTypeOption === option ? 'active' : ''}`}
                            onClick={(e) => { e.stopPropagation(); onChangeBillType(option)(); setBillTypeDropdownOpen(false); }}
                            style={{paddingBottom:billTypeOption === option ?"3px":"7px"}}
                        >
                            <p readOnly style={{ margin: "0", fontSize: "0.8rem" }}>
                                {option}
                            </p>
                        </div>
                    ))
               }
              </div>
            )}

            {
                    showAggregator &&
                    <div className="aggregate-ctn" ref={menuRef} style={{
                      position: 'fixed',
                      top: billTypeTriggerRef.current ? billTypeTriggerRef.current.getBoundingClientRect().bottom + 2 : 0,
                      left: billTypeTriggerRef.current ? billTypeTriggerRef.current.getBoundingClientRect().left : 0,
                      zIndex: 1100,
                    }}>
                        {
                            aggregatorList.length !== 0 ?
                                aggregatorList?.map((item, i) => (
                                    <div
                                        onClick={aggregatorSelected(item)}
                                        key={i}
                                        style={{ backgroundColor: (aggregator?._id === item?._id) ? "rgb(64 19 19)" : "#795547" }}
                                    >
                                        {item?.name}
                                    </div>
                                ))
                                :
                                <div>No Records !!</div>
                        }
                    </div>
                }
           </> }
            <div
                className="billing-left-secoundnav-container"
                style={{width:btnClicked&&"69%"}}
            >
                <button className="top-bar-buttons billing-btn-2">
                    <span
                        onClick={() =>{
                            dispatch(setDialogBox("addCustomer")) 
                            dispatch(setVisibleKeyboard(null))}}
                        className="circle-button justify-center">{customer===null?"+":<EditIcon/> }</span>
                    <div style={{ flex: "1" }}>
                        <CustomerListPopup/>
                    </div>
                </button>
                <button
                    onClick={() =>buttonsOnClick("viewOrder")}
                    className="top-bar-buttons billing-btn-3"
                    style={{
                        backgroundColor:(btnClicked==="viewOrder")?"#fff":"rgb(21 128 145)",
                        color:(btnClicked==="viewOrder")?"rgb(4 221 255)":"#fff",
                    }}
                    >View Order</button>
                <button
                    style={{
                        backgroundColor:(btnClicked==="heldOrder")?"#fff":"#cc5200",
                        color:(btnClicked==="heldOrder")?"#cc5200":"#fff",
                        position: "relative"
                    }}
                    onClick={() =>buttonsOnClick("heldOrder")}
                    className="top-bar-buttons billing-btn-4">Ongoing Orders
                        {
                        onGoingOrderCount>0&&
                        <span
                            style={{
                                padding: "2px 5px",
                                backgroundColor: "#fff",
                                marginLeft:"4px",
                                color:"#cc5200",
                                border:"1px solid #cc5200"
                            }}
                        >
                        {onGoingOrderCount}
                        </span>}
                </button>

                {
                    billTypeOption === "Dine In" &&
                    <button
                    style={{
                        backgroundColor:(btnClicked==="floorPlan")?"#fff":"rgb(0 6 193)",
                        color:(btnClicked==="floorPlan")?"rgb(6 0 255)":"#fff",
                        position: "relative"
                    }}
                    onClick={() =>buttonsOnClick(btnClicked==="tableChange"?"tableChange":"floorPlan")}
                        className="top-bar-buttons billing-btn-table">Tables
                    </button>}

                    <button
                    style={{
                        backgroundColor:(btnClicked==="reservation")?"#fff":"#0f3e01",
                        color:(btnClicked==="reservation")?"#0f3e01":"#fff",
                        position: "relative"
                    }}
                    onClick={() =>buttonsOnClick("reservation")}
                        className="top-bar-buttons billing-btn-table">
                        Reservation
                        {
                        reservationList && reservationList?.pendingCount!==0&&
                        <span
                            style={{
                                padding: "2px 5px",
                                backgroundColor: "#fff",
                                marginLeft:"4px",
                                color:"#0f3e01",
                                border:"1px solid #0f3e01"
                            }}
                        >
                        {reservationList?.pendingCount}
                        </span>}
                    </button>
            </div>

            <div className="billing-search-bar">
                <SearchIcon
                sx={{cursor:"pointer"}}
                className="billing-search-icon" />
                <input
                    type="text"
                    placeholder={`Search ${btnClicked===null?"products":"orders"} by name..`}
                    className="search-bar"
                    value={searchBarInput ?? ''} 
                    onChange={searchInputOnChange}
                    onFocus={(e)=>e.target.select()}
                />
            <IconButton
                onMouseDown={(e) => e.stopPropagation()}
                onClick={() => dispatch(setVisibleKeyboard(keyBoardVisible === "searchKeyboard" ? null : "searchKeyboard"))}
            >
                <KeyboardIcon/>
            </IconButton>
            </div>


            {/* add customer */}
        <Dialog
            open={dialogOpen==="addCustomer"}
            onClose={closeCustomerDialog}
            maxWidth="fit-content"
        >
            <AddCustomerFromReservation setCustomerPopup={setAddCustomerDialog} />
        </Dialog>

        <Dialog 
        open={dialogOpen==="aggregatorRef"} 
        maxWidth="lg"
        >
            <div className='wallet-change-dialog' style={{maxWidth:keyBoardVisible==="referenceKb"?"fit-content":"750px"}}>
                <div className="head justify-center">
                    <div className="icon justify-center" style={{backgroundColor:"#ffa50030"}}>
                        <DeliveryDiningIcon sx={{color:"#ff7201"}}/>
                    </div>
                    Add Refference ID
                </div>
                <div className="input-ctn">
                    <button disabled className="btn" style={{width:"80px",textAlign:"start"}}>Aggregator</button>
                    <input type="text"
                        readOnly
                        value={aggregator?.name}
                        style={{ textAlign: "start", paddingLeft: "10px" }}
                    />
                </div>
                <div className="input-ctn">
                    <button disabled className="btn" style={{width:"80px",textAlign:"start"}}>REF ID</button>
                    <input type="text"
                        value={aggregatorRef}
                        onChange={(e)=>{
                                         dispatch(setAggregatorRef(e.target.value))
                                         setAggregatorRefValidation(false)}}
                        style={{ textAlign: "start", paddingLeft: "10px" }}
                    />
                     <IconButton
                          sx={{padding:"0 5px"}}
                              onClick={() => {dispatch(setVisibleKeyboard(keyBoardVisible==="referenceKb"?null:"referenceKb"))}}
                          >
                              <KeyboardIcon
                               sx={{color:keyBoardVisible?"red !important":'#7a7a7a !important'}}/>
                          </IconButton>
                    {
                        aggregatorRefValidation &&
                    <p className="doc-validation-alert" style={{margin:"0"}}>Refference is required !!</p>}
                </div>
                {keyBoardVisible==="referenceKb" &&
                <CustomeKeyBoard
                    input={aggregatorRef}
                    setInput={(value) =>dispatch(setAggregatorRef(value))
                    }
                    // inputRef={customerAutocompletRef}
                />}
                <div className="wallet-change-btn">
                    <button
                        onClick={onCloseAggReference}
                        className="btn-secondary-outlined btn">Cancel</button>
                    <button
                        style={{backgroundColor:"#ff7201"}}
                        className="btn-primary btn"
                        onClick={()=>(aggregatorRef===null || aggregatorRef==="")?setAggregatorRefValidation(true)  :dispatch(setDialogBox(null))}>Submit</button>
                </div>
            </div>
        </Dialog>
        {/* Self Delivery KM Dialog */}
        <Dialog 
        open={!!kmDialogOpen}
        onClose={()=>setKmDialogOpen(false)}
        >
            <div className='wallet-change-dialog' style={{maxWidth:'420px'}}>
                <div className="head justify-center">
                    <div className="icon justify-center" style={{backgroundColor:"#e0f7ff"}}>
                        <DeliveryDiningIcon sx={{color:"#0077aa"}}/>
                    </div>
                    Enter Kilometers
                </div>
                <div className="input-ctn">
                    <button disabled className="btn" style={{width:"120px",textAlign:"start"}}>Distance (Km)</button>
                    <input type="number"
                        min={0}
                        value={kmInput ?? ''}
                        onChange={(e)=> {
                            const raw = e.target.value;
                            setKmInput(raw);
                            const km = Number(raw);
                            // Validate km range in real-time
                            const mode = branchConfig?.deliveryChargeMode || 'flat';
                            if (mode === 'km_range' && km > 0) {
                                const rules = Array.isArray(branchConfig?.kmRangeRules) ? branchConfig.kmRangeRules : [];
                                const match = rules.find(r => Number(r?.fromKm) <= km && km <= Number(r?.toKm));
                                if (!match) {
                                    if (rules.length > 0) {
                                        const rangeText = rules.map(r => `${r?.fromKm}-${r?.toKm} km`).join(', ');
                                        setKmDialogError(`${km} km is outside delivery ranges. Available: ${rangeText}`);
                                    } else {
                                        setKmDialogError('No delivery ranges configured');
                                    }
                                } else {
                                    setKmDialogError(null);
                                }
                            } else {
                                setKmDialogError(null);
                            }
                        }}
                        style={{ textAlign: "start", paddingLeft: "10px" }}
                    />
                </div>
                {/* Delivery Boy Selection */}
                <div className="input-ctn" style={{marginTop: '10px'}}>
                    <button disabled className="btn" style={{width:"120px",textAlign:"start"}}>Delivery Boy</button>
                    <Autocomplete
                        options={allActiveEmpList || []}
                        getOptionLabel={(option) => option?.staff_name || ""}
                        value={selectedDeliveryBoy}
                        onChange={(e, newValue) => setSelectedDeliveryBoy(newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Optional"
                                variant="standard"
                                InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    style: { 
                                        textAlign: "start", 
                                        paddingLeft: "10px",
                                        fontSize: "14px"
                                    }
                                }}
                            />
                        )}
                        sx={{
                            flex: 1,
                            '& .MuiAutocomplete-inputRoot': {
                                padding: '0 !important',
                                height: '38px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                '&:hover': {
                                    borderColor: '#888'
                                },
                                '&.Mui-focused': {
                                    borderColor: '#0077aa',
                                    boxShadow: '0 0 0 2px rgba(0, 119, 170, 0.1)'
                                }
                            },
                            '& .MuiAutocomplete-input': {
                                padding: '0 10px !important'
                            }
                        }}
                        isOptionEqualToValue={(option, value) => option?._id === value?._id}
                    />
                </div>
                {kmDialogError && (
                    <div style={{
                        backgroundColor: '#fff3cd',
                        border: '1px solid #ffc107',
                        borderRadius: '4px',
                        padding: '8px 12px',
                        margin: '10px 0',
                        color: '#856404',
                        fontSize: '13px',
                        textAlign: 'center'
                    }}>
                        ⚠️ {kmDialogError}
                    </div>
                )}
                <div className="wallet-change-btn">
                    <button
                        onClick={()=>{ setKmDialogOpen(false); setKmInput(0); setKmDialogError(null); }}
                        className="btn-secondary-outlined btn">Cancel</button>
                    <button
                        style={{
                            backgroundColor: kmDialogError ? "#cccccc" : "#0077aa",
                            cursor: kmDialogError ? "not-allowed" : "pointer",
                            opacity: kmDialogError ? 0.6 : 1
                        }}
                        className="btn-primary btn"
                        disabled={!!kmDialogError}
                        onClick={()=>{
                            if (kmDialogError) return; // Prevent action if error exists
                            const mode = branchConfig?.deliveryChargeMode || 'flat';
                            const perKm = Number(branchConfig?.perKmCharge || 0);
                            const flat = Number(branchConfig?.deliveryAmt || 0);
                            let charge = 0;
                            if (mode === 'per_km') {
                                charge = Math.max(0, (perKm || 0) * Math.max(0, Number(kmInput)));
                            } else if (mode === 'km_range') {
                                const rules = Array.isArray(branchConfig?.kmRangeRules) ? branchConfig.kmRangeRules : [];
                                const match = rules.find(r => Number(r?.fromKm) <= Number(kmInput) && Number(kmInput) <= Number(r?.toKm));
                                if (match) {
                                    charge = match?.isFree ? 0 : Number(match?.charge || 0);
                                } else {
                                    charge = 0; // default if no range matched
                                }
                            } else {
                                charge = flat;
                            }
                            dispatch(setSelfDeliveryKm(Math.max(0, Number(kmInput))));
                            dispatch(setSelfDeliveryCharge(Number(charge)));
                            dispatch(setDeliveryBoy(selectedDeliveryBoy));
                            console.log('✅ Delivery details saved:', { km: Number(kmInput), charge, deliveryBoy: selectedDeliveryBoy?.staff_name });
                            setKmDialogOpen(false);
                            setKmDialogError(null); // Clear error on close
                        }}>Apply</button>
                </div>
            </div>
        </Dialog>
        {
            keyBoardVisible === "customerKeyboard" &&
            <div className="billing-keyboard-position" style={{zIndex:"1020"}}>
                <CustomeKeyBoard
                    input={customerTextfieldInput}
                    setInput={(value) => customerTextfieldChange(value)}
                    // inputRef={customerAutocompletRef}
                />
            </div>
        }
        </div>
  )
}

export default TopBar